import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { instanceOf, node, string } from "prop-types";

const createdPortalElements = {};
const setPortalElementDiv = (
  portalElementClass,
  portalElementId,
  setPortalElement
) => {
  if (portalElementId) {
    if (!createdPortalElements[portalElementId]) {
      createdPortalElements[portalElementId] = document.createElement("div");
      createdPortalElements[portalElementId].id = portalElementId;

      if (portalElementClass) {
        createdPortalElements[portalElementId].setAttribute(
          "class",
          portalElementClass
        );
      }
    }

    setPortalElement(createdPortalElements[portalElementId]);
  } else {
    setPortalElement(document.createElement("div"));
  }
};

const Portal = ({
  children,
  container,
  mountPoint,
  portalElementClass,
  portalElementId
}) => {
  const [portalElement, setPortalElement] = useState(container);
  const [mountElement, setMountElement] = useState(mountPoint);

  useEffect(() => {
    if (!portalElement) {
      setPortalElementDiv(
        portalElementClass,
        portalElementId,
        setPortalElement
      );
    }

    if (!mountElement) {
      setMountElement(document.body);
    }

    if (portalElement && mountElement) {
      mountElement.appendChild(portalElement);
    }

    return () => {
      if (
        portalElement &&
        mountElement &&
        mountElement.contains(portalElement)
      ) {
        portalElement.parentNode.removeChild(portalElement);
      }
    };
  }, [portalElement, mountElement]);

  useEffect(() => {
    if (mountPoint && mountPoint !== mountElement) {
      setMountElement(mountPoint);
    }
  }, [mountPoint]);

  if (portalElement && mountElement) {
    return createPortal(children, portalElement);
  }

  return null;
};

Portal.propTypes = {
  container: instanceOf(Element),
  children: node.isRequired,
  mountPoint: instanceOf(Element),
  portalElementClass: string,
  portalElementId: string
};

Portal.defaultProps = {
  container: null,
  mountPoint: null,
  portalElementClass: null,
  portalElementId: null
};

export default Portal;
